import { render, staticRenderFns } from "./ParkingBarriersArchive.vue?vue&type=template&id=9c6bed4a&scoped=true&"
import script from "./ParkingBarriersArchive.vue?vue&type=script&lang=js&"
export * from "./ParkingBarriersArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6bed4a",
  null
  
)

export default component.exports